
        import { ubcLog } from '../../src/lib/log';
        import brandScheme from '../../src/lib/utils/brandScheme';
        import { UgInvokeApp } from '../../src/lib/utils/ugInvokeApp';
        import { GET_DOWNLOAD_URL,LATEST_VERSION } from '../../src/lib/constants/api';
        import {isHarmonyOS} from '@src/lib/utils/tools';
        import {httpGet} from '@src/lib/utils/request';
        var cfromList = [
            '1035069a',
            '1035703a',
            '1034743a',
            '1034867a',
            '1034867b',
            '1034867c',
            '1034867d',
            '1034867e',
            '1034867f',
            '1034867g',
            '1034866a',
            '1034866b',
            '1035091a',
            '1034866c',
        ];
        var btn = document.getElementById('download-btn');
        var aLink = document.getElementById('download-btn-link');
        var UA = window.navigator.userAgent.toLowerCase();
        var isAndroid = UA.indexOf('android') > 0;
        var isIOS = /iPhone|iPad|iPod/i.test(UA);
        var isWeChat = /micromessenger/i.test(UA);
        var tips = document.getElementById('tips');
        var overlay = document.getElementById('overlay');
        var downloadLink = 'https://testflight.apple.com/join/' + getQuery('tf');
        var canJumpTf = getQuery('tf') !== '';
        var cfrom = getQuery('whfrom') || getQuery('cfrom');
        var ct = getQuery('ct') || '';
        // 默认调起
        var auto = getQuery('auto') || '';
        var hasCfrom = !!getQuery('whfrom') || (getQuery('cfrom') && cfromList.includes(cfrom));
        var isAuto = 0;
        var sceneName = getQuery('sceneName') || '';
        var ugInvoke = sceneName && new UgInvokeApp();
        var openDetailUrl = getQuery('openDetailUrl') || '';
        function getInvokeInfo() {
            const invokeInfoList = {
                create_video: {
                    tab: 'prompt',
                    child_tab: '51',
                    source: '',
                },
                // 测试使用
                study_test: {
                    title: encodeURIComponent('学**国公文助手内测版'),
                    characterId: '1098018',
                },
                // 线下渠道
                study_offline: {
                    title: encodeURIComponent('学习强国公文助手'),
                    characterId: '1139569',
                },
                // 线下渠道
                study_online: {
                    title: encodeURIComponent('学习强国公文助手'),
                    characterId: '1139569',
                },
                // 打开app
                invoke_home: {
                    extFrom: 'share',
                },
                open_detail: {
                    openDetailUrl: isIOS ? encodeURIComponent(encodeURIComponent(openDetailUrl)) : encodeURIComponent(openDetailUrl),
                },
            }
            ugInvoke.getInvokeInfo({
                [sceneName]: invokeInfoList[sceneName] || {},
            });
            // 下载按钮微信开放标签渲染
            ugInvoke.renderWxTag({
                wxConf: {
                    wxDom: btn,
                    onClick: () => { },
                },
                sceneName,
            });
        }
        sceneName && getInvokeInfo();
        // 获取query参数
        function getQuery(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return '';
        }
        // 获取带鉴权功能的APK下载地址
        function getDownloadUrl() {
            const officialChannel = '1035069b';
            const channelId = cfrom || officialChannel;
            return url = `https://downpack.baidu.com/newapp_AndroidPhone_${channelId}.apk`;
        }

        function getLastestVersion() {
            const url = LATEST_VERSION;
            httpGet({
                url
            }).then(res => {
                const versionKey = 'latest_version';
                const lastestVersion = res?.data?.data?.[versionKey] || '';
                const versionElement = document.getElementById('version');
                versionElement.innerText=`版本号：${lastestVersion}`;
            });
        };

        function getLinkHref(){
            if(isHarmonyOS){
                aLink.href='store://appgallery.huawei.com/app/detail?id=com.baidu.yiyan';
            }
        }

        // if (!isIOS) {
            // tips.style.display = 'flex';
        // }

        aLink.addEventListener('click', function (e) {

            e.stopPropagation();
        })
        // 下载按钮点击
        btn.addEventListener('click', async function (e, type) {
            // 点击打点
            ubcLog({
                params: {
                    type: 'click',
                    value: 'button',
                    page: 'download',
                },
                ext: {
                    'system': isIOS ? 'ios' : 'android',
                    'is_auto': isAuto ? 1 : 0,
                    'link': window.location.href,
                },
            });
            isAuto = 0;
            if (sceneName) {
                ugInvoke.execInvoke(sceneName);
                return;
            }

            /* <==========下面是下载逻辑=================> */
            if (isAndroid) {
                if (isWeChat) {
                    overlay.style.display = 'block';
                    e.preventDefault();
                    return false;
                }
                
                var judgeBrandScheme = brandScheme(UA);
                if (hasCfrom) {
                    // 如果是安卓，并且区分渠道号
                    const url = await getDownloadUrl();
                    aLink.href = url;
                    url && aLink.click();
                    e.preventDefault();
                    return false;
                } else if (judgeBrandScheme && UA.indexOf('baiduboxapp') < 0) {
                    // 如果是安卓 (华为/小米/oppo/vivo)，直接到应用市场
                    window.location.href = judgeBrandScheme;
                    e.preventDefault();
                    return false;
                }
            }
            else if (isHarmonyOS) {
                aLink.href = 'store://appgallery.huawei.com/app/detail?id=com.baidu.yiyan';
                aLink.click();
            }

            else {
                aLink.href = 'https://itunes.apple.com/cn/app/id6446882473?mt=8&ct=' + ct;
                aLink.click();
                e.preventDefault();
                return false;
            }

            // pc上也走安卓端上下载的逻辑
            if (hasCfrom) {
                const url = await getDownloadUrl();
                aLink.href = url;
                url && aLink.click();
                e.preventDefault();
                return false;
            }

            aLink.click();
        });
        // 点击蒙层，蒙层消失
        overlay.addEventListener('click', function (e) {
            overlay.style.display = 'none';
        });

        window.onload = function () {
            ubcLog({
                params: {
                    type: 'display',
                    page: 'download',
                },
                ext: {
                    'system': isIOS ? 'ios' : 'android',
                    'link': window.location.href,
                },
            });
            // 获取版本号
            getLastestVersion();
            // 如果是鸿蒙，修改link地址
            getLinkHref();
        };
    